import { Navigate, Route, Routes } from "react-router-dom";

import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Backfill } from "@/pages/Backfill";
import { Dashboard } from "@/pages/Dashboard";
import { LeadDetail } from "@/pages/LeadDetail";
import { LeadhoopDashboard } from "@/pages/LeadhoopDashboard";
import { LeadhoopLeadDetailPage } from "@/pages/LeadhoopLeadDetail";
import { LeadhoopLeads } from "@/pages/LeadhoopLeads";
import { LeadhoopSyncRuns } from "@/pages/LeadhoopSyncRuns";
import { Leads } from "@/pages/Leads";
import { Login } from "@/pages/Login";
import { SyncRuns } from "@/pages/SyncRuns";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="leads" element={<Leads />} />
        <Route path="leads/:id" element={<LeadDetail />} />
        <Route path="backfill" element={<Backfill />} />
        <Route path="sync-runs" element={<SyncRuns />} />

        {/* LeadHoop */}
        <Route path="leadhoop" element={<LeadhoopDashboard />} />
        <Route path="leadhoop/leads" element={<LeadhoopLeads />} />
        <Route
          path="leadhoop/leads/:accountSlug/:recordId"
          element={<LeadhoopLeadDetailPage />}
        />
        <Route path="leadhoop/sync-runs" element={<LeadhoopSyncRuns />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
